// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_CreateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/create
 *
 * Creates a new service order.
 */
import { registerContract } from './validate'

export interface Orders_CreateInput {
so_order_franchise_id: number
so_order_client_id: number
so_order_origin?: string
so_order_notes?: string
}

registerContract('Orders_CreateInput', {
  so_order_franchise_id: { type: 'number',  required: true },
  so_order_client_id:    { type: 'number',  required: true },
  so_order_origin:       { type: 'string',  required: false },
  so_order_notes:        { type: 'string',  required: false },
})
